import { yupResolver } from '@hookform/resolvers/yup'
import { Grid } from '@mui/material'
import React, { useMemo } from 'react'
import { FormProvider, useForm } from 'react-hook-form'

import PageSection from 'components/common/PageSection'
import { getAuthenticationFormValidationSchema } from 'components/status-checks/authentication-form-schema-builders'
import {
  type AuthenticationFormValues,
  getDefaultAuthenticationFormValues
} from 'components/status-checks/authentication-form-utils'
import { ObservabilityToolAuthentication } from 'components/status-checks/form/authentication/ObservabilityToolAuthentication'
import { useStatusCheckExternalIntegrationsContext } from 'context/status-checks/StatusCheckExternalIntegrationsContext'
import { IntegrationType } from 'utils/team-external-integrations/team-external-integration-types'

export const CreateAuthenticationForm: React.FC = () => {
  const {
    isLoadingExternalIntegrations,
    hasErrorExternalIntegrations,
    getAvailableExternalIntegrations
  } = useStatusCheckExternalIntegrationsContext()

  const [allExternalIntegrations, unsavedExternalIntegrations] = useMemo(() => {
    const allExternalIntegrations = getAvailableExternalIntegrations(false)
    const unsavedExternalIntegrations = getAvailableExternalIntegrations(true)
    const awsIntegrations = allExternalIntegrations.filter(
      ({ isConfigured, type }) => type === IntegrationType.AWS && !isConfigured
    )

    return [
      allExternalIntegrations,
      // Adds the based AWS integration to the unsaved integrations list
      [...unsavedExternalIntegrations, ...awsIntegrations]
    ]
  }, [getAvailableExternalIntegrations])

  const authenticationFormValidationSchema =
    getAuthenticationFormValidationSchema(allExternalIntegrations)

  const form = useForm<AuthenticationFormValues>({
    mode: 'onChange',
    defaultValues: getDefaultAuthenticationFormValues(),
    resolver: yupResolver(authenticationFormValidationSchema)
  })

  return (
    <PageSection
      hasError={hasErrorExternalIntegrations}
      isLoading={isLoadingExternalIntegrations}
    >
      <FormProvider {...form}>
        <Grid container>
          <Grid item lg={9} xs={12}>
            <ObservabilityToolAuthentication
              externalIntegrations={unsavedExternalIntegrations}
            />
          </Grid>
        </Grid>
      </FormProvider>
    </PageSection>
  )
}
